import moment from "moment";

export default class DateUtils {
	public static toUTCDate = (date: Date): string => {
		return moment(date).toISOString(true);
	}
}